import { Link } from 'react-router-dom';
import { BrandMark } from './BrandMark';

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="site-footer__grid">
        <div className="site-footer__brand">
          <BrandMark />
          <p>An AI-assisted tool for organising thoughts, exploring options, and personal reflection.</p>
        </div>
        <div>
          <p className="footer-label">Product</p>
          <Link to="/workspace">Workspace</Link>
          <Link to="/pricing">Pricing</Link>
          <Link to="/support">Support</Link>
        </div>
        <div>
          <p className="footer-label">Legal</p>
          <Link to="/terms">Terms</Link>
          <Link to="/privacy">Privacy</Link>
          <Link to="/refund-policy">Refund policy</Link>
        </div>
        <div>
          <p className="footer-label">Company</p>
          <span>GHOSTPROBE LTD</span>
          <a href="mailto:info@ghostprobe.co.uk">info@ghostprobe.co.uk</a>
        </div>
      </div>
      <div className="site-footer__bottom">
        <span>© 2026 GHOSTPROBE LTD</span>
        <span>Structured for reflection, created for entertainment.</span>
      </div>
      <p className="site-footer__registration">
        Registered in England and Wales. Company number 17267835.
      </p>
    </footer>
  );
}
